import { useCallback } from "react";
import { ServiceEnvironment } from "Enums/ServiceEnvironment";
import { CentralAdminEntityType } from "Enums/CentralAdminEntityType";
import { centralAdminItemSchema } from "Shared/Components/Scope/Topology/CentralAdminTopology";
import { ScopeItem } from "Shared/Components/Scope/Scopes.types";
import { useORPCClient } from "Core/oRPC";

export const useSubstrateRegion = () => {
    const orpcClient = useORPCClient();

    const getRegionList = useCallback(
        async (env?: ServiceEnvironment, workload?: string): Promise<ScopeItem[]> => {
            const regionRequest = {
                Environment: env,
                Workload: workload || "",
                TargetType: CentralAdminEntityType.Region
            };
            const regionOut = await orpcClient.inventoryApi.postTopology(regionRequest);
            const regionParsedOutput = centralAdminItemSchema.array().parse(regionOut);
            const allOption: ScopeItem = { ScopeType: "Region", Value: "All" };
            return [allOption, ...regionParsedOutput.map((item) => ({ ScopeType: "Region", Value: item.Name }))];
        },
        [orpcClient]
    );

    return {
        getRegionList
    };
};
